(() => {
  /* ------------------------------------------------------------------
     SECTION 1 – Ajax Add-to-Cart + Drawer & Badge Refresh
  ------------------------------------------------------------------ */

  const $document                = $(document);
  const SECTIONS_TO_REFRESH       = 'cart-drawer,cart-icon-bubble';
  const HEADER_CART_ICON_SELECTOR = '[aria-controls="CartDrawer"], .header__icon--cart, a[href$="/cart"]';

  /* Toast message helper */
  function showToast(message, type) {
    $('#cart-message').remove();
    $('<div>', { id: 'cart-message', class: type, text: message })
      .appendTo('body')
      .fadeIn()
      .delay(3000)
      .fadeOut();
  }

  /* Open the cart drawer (or fall back to clicking the header icon) */
  function openCartDrawer() {
    const drawerElement = document.querySelector('cart-drawer');
    drawerElement?.open?.() || document.querySelector(HEADER_CART_ICON_SELECTOR)?.click();
  }

  /* Replace drawer HTML and refresh the header badge */
  function refreshCartSections(sections) {
    /* 1. Drawer content */
    const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    if (drawerInner && sections['cart-drawer']) {
      const freshInner = new DOMParser()
        .parseFromString(sections['cart-drawer'], 'text/html')
        .querySelector('.drawer__inner');
      if (freshInner) drawerInner.innerHTML = freshInner.innerHTML;
    }

    /* 2. Header icon badge */
    if (sections['cart-icon-bubble']) {
      const headerIcon = document.querySelector(HEADER_CART_ICON_SELECTOR);
      if (headerIcon) {
        const parsedDocument = new DOMParser()
          .parseFromString(sections['cart-icon-bubble'], 'text/html');

        /* Remove the stale bits */
        headerIcon
          .querySelectorAll('.svg-wrapper, .visually-hidden, .cart-count-bubble')
          .forEach(node => node.remove());

        /* Append the fresh bits */
        parsedDocument
          .querySelectorAll('.svg-wrapper, .visually-hidden, .cart-count-bubble')
          .forEach(node => headerIcon.appendChild(node));
      }
    }

    /* Drawer should no longer be marked empty */
    document.querySelector('cart-drawer')?.classList.remove('is-empty');
  }

  /* Main click handler for every “Add to Cart” button */
  function handleAddToCartClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const $button      = $(event.currentTarget);
    const $productCard = $button.closest('.product-card');
    const variantId    = $productCard.find('[name=id]').val()
                       || $button.data('variant-id')
                       || $button.attr('id').replace('slider-product-', '');
    const quantity     = +$productCard.find('[name=quantity]').val() || 1;

    /* UI feedback while processing */
    $button.prop('disabled', true).text('Adding…');

    /* 1. Add the item with Shopify Ajax API */
    $.post('/cart/add.js', { id: variantId, quantity: quantity })

      /* 2. On success, re-render the drawer and badge */
      .done(() => {
        fetch('/?sections=' + SECTIONS_TO_REFRESH)
          .then(response => response.json())
          .then(sections => {
            refreshCartSections(sections);
            openCartDrawer();
            showToast('Product added to cart!', 'success');
          });
      })

      /* 3. On error, show an error toast */
      .fail(xhr => {
        let message = 'Failed to add product';
        try {
          message = JSON.parse(xhr.responseText).description || message;
        } catch (_) { /* ignore JSON errors */ }
        showToast(message, 'error');
      })

      /* 4. Always re-enable the button */
      .always(() => {
        $button.prop('disabled', false).text('Add to Cart');
      });
  }

  /* Register the click handler (avoid duplicates) */
  $document
    .off('click.ajaxCart', '.ajax-add-to-cart-btn')
    .on ('click.ajaxCart', '.ajax-add-to-cart-btn', handleAddToCartClick);



  /* ------------------------------------------------------------------
     SECTION 2 – Product Slider (Swiper)
  ------------------------------------------------------------------ */

  /* Avoid re-initialising Swiper if the section is re-rendered */
  function initialiseProductSliders() {
    document.querySelectorAll('.custom-block-product-slider-swiper').forEach(container => {
      /* If Swiper already exists on this container, destroy it first */
      if (container.swiper) container.swiper.destroy(true, true);

      /* Create a new Swiper instance */
      container.swiper = new Swiper(container, {
        slidesPerView : 4,
        spaceBetween  : 20,
        loop          : true,
        navigation    : {
          nextEl : container.querySelector('.swiper-button-next'),
          prevEl : container.querySelector('.swiper-button-prev')
        },
        breakpoints   : {
          320 : { slidesPerView: 1.5, centeredSlides: true },
          480 : { slidesPerView: 2   },
          768 : { slidesPerView: 4   }
        }
      });
    });
  }

  /* Run initialisation once the DOM is ready */
  function initEverything() {
    initialiseProductSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEverything);
  } else {
    initEverything();
  }
})();
